module.exports = __webpack_public_path__ + "img/50.2b37017b.jpg";